"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var formik_1 = require("formik");
var client_1 = require("@apollo/client");
var style_1 = __importDefault(require("./style"));
var Form = function (_a) {
    var mutation = _a.mutation, mutationVariablesFormatter = _a.mutationVariablesFormatter, children = _a.children, formikProps = _a.formikProps, onSuccess = _a.onSuccess, _b = _a.skipMutation, skipMutation = _b === void 0 ? false : _b;
    var mutationAction = client_1.useMutation(mutation)[0];
    var onSubmit = function (formikValues, formikHelpers) {
        console.log("Form.onSubmit", formikValues);
        if (skipMutation) {
            formikHelpers.setSubmitting(false);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(formikValues, {});
            return;
        }
        mutationAction({ variables: mutationVariablesFormatter(formikValues) })
            .then(function (response) {
            console.log("Form.onSubmit - response", response);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(formikValues, response);
        })
            .catch(function (e) {
            console.log("Form.onSubmit - error", e);
            console.log("Form.onSubmit - e?.graphQLErrors", e === null || e === void 0 ? void 0 : e.graphQLErrors);
            e === null || e === void 0 ? void 0 : e.graphQLErrors.forEach(function (graphQLError) {
                var _a;
                if ((_a = graphQLError === null || graphQLError === void 0 ? void 0 : graphQLError.context) === null || _a === void 0 ? void 0 : _a.field) {
                    formikHelpers.setFieldError(graphQLError.context.field, graphQLError.message);
                }
            });
        })
            .finally(function () {
            formikHelpers.setSubmitting(false);
        });
    };
    return (react_1.default.createElement(style_1.default, null,
        react_1.default.createElement(formik_1.Formik, __assign({}, formikProps, { onSubmit: onSubmit }), function (props) { return (react_1.default.createElement(formik_1.Form, null, typeof children === "function" ? children({ props: props }) : children)); })));
};
exports.default = Form;
